import axios from 'axios';

const BASE = 'https://api.tnpschub.msdiscoveries.com/api';

const api = axios.create({ baseURL: BASE, timeout: 15000 });

api.interceptors.request.use(cfg => {
  const t = localStorage.getItem('tnpsc_token');
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(r => r, err => {
  if (err.response?.status === 401) {
    const errData = err.response?.data;
    if (errData?.error === 'SESSION_EXPIRED') {
      localStorage.clear();
      sessionStorage.setItem('login_notice', errData.message || 'Session expired. Please login again.');
      window.location.href = '/login';
    } else {
      localStorage.clear();
      window.location.href = '/login';
    }
  }
  return Promise.reject(err);
});

export default api;

export const authAPI = {
  register:        d  => api.post('/auth/register', d),
  login:           d  => api.post('/auth/login', d),
  adminLogin:      d  => api.post('/auth/admin/login', d),
  logout:          () => api.post('/auth/logout'),
  forgotPassword:  d  => api.post('/auth/forgot-password-request', d),
};

export const paymentAPI = {
  submit:  (user_id, utr_id) => api.post('/payment/submit', { user_id, utr_id }),
  getAll:  status            => api.get('/admin/payments', { params: { status } }),
  update:  (id, data)        => api.put(`/admin/payments/${id}`, data),
};

export const userAPI = {
  getProfile:      () => api.get('/user/profile'),
  updateProfile:   d  => api.put('/user/profile', d),
  changePassword:  d  => api.put('/user/change-password', d),
  getDashboard:    () => api.get('/user/dashboard'),
};

// ── BATCH API ─────────────────────────────────────────────────
export const batchAPI = {
  getAll:    ()         => api.get('/batches'),
  getOne:    id         => api.get(`/batches/${id}`),
  start:     id         => api.get(`/batches/${id}/start`),
  submit:    (id, data) => api.post(`/batches/${id}/submit`, data),
  getResult: (batchId, resultId) => api.get(`/batches/${batchId}/result/${resultId}`),
};

export const questionAPI = {
  getAll:   params => api.get('/admin/questions', { params }),
  add:      d      => api.post('/admin/questions', d),
  update:   (id,d) => api.put(`/admin/questions/${id}`, d),
  delete:   id     => api.delete(`/admin/questions/${id}`),
  getStats: ()     => api.get('/admin/questions/stats'),
};

export const testAPI = {
  getHistory: ()  => api.get('/tests/history'),
  // legacy compat
  getAvailable: () => api.get('/tests'),
};

export const adminAPI = {
  getStats:           ()        => api.get('/admin/stats'),
  getUsers:           params    => api.get('/admin/users', { params }),
  getUserDetails:     id        => api.get(`/admin/users/${id}`),
  approveUser:        id        => api.post(`/admin/users/${id}/approve`),
  rejectUser:         id        => api.post(`/admin/users/${id}/reject`),
  blockUser:          id        => api.post(`/admin/users/${id}/block`),
  editUser:           (id,data) => api.put(`/admin/users/${id}/edit`, data),
  resetUserPassword:  (id,pwd)  => api.post(`/admin/users/${id}/reset-password`, { new_password: pwd }),
  deleteUser:         id        => api.delete(`/admin/users/${id}`),
  getPwdResetRequests:()        => api.get('/admin/password-reset-requests'),
  resolvePwdRequest:  id        => api.put(`/admin/password-reset-requests/${id}/resolve`),
  getBatches:         ()        => api.get('/admin/batches'),
  updateBatch:        (id,data) => api.put(`/admin/batches/${id}`, data),
  unlockBatch:        (userId, batchNo) => api.post(`/admin/users/${userId}/unlock-batch/${batchNo}`),
  resetProgress:      userId    => api.post(`/admin/users/${userId}/reset-progress`),
};

export const notificationAPI = {
  getAll:      () => api.get('/user/notifications'),
  markAllRead: () => api.put('/user/notifications/read-all'),
};

export const pwdResetAPI = {
  request: () => api.post('/user/password-reset-request'),
};
